import axios, { AxiosResponse } from 'axios';
import { Fund, ChartData } from 'funds-model';
import { ToISODateOptions } from 'luxon';


export const getFundsChartData = (
  funds: Fund[], fromDate: string, endDate: string | ((options?: ToISODateOptions) => string), unitCategoryCode: string, chartType = 'pricing'
): Promise<AxiosResponse<ChartData>[]> => {
  const url = `api/funds/quotes/chart/${chartType}`;

  return Promise.all(funds.filter(fund => fund != null).map(fund => axios.get<ChartData>(url, { params: {
    fundId: fund.id,
    fromDate,
    endDate,
    unitCategoryCode
  }})));
};

export const getFundsChartLastDate = (fundId: number, unitCategoryCodes: string) => {
  return axios.get('api/funds/quotes/last-date', { params: { fundId, unitCategoryCodes }}).then((res) => res.data);
};

export const getOneFundChartData = (fundId: number, unitCategoryCodes: string, actualFromDate?: string): Promise<ChartData> => {
  const url = `funds/quotes/chart/pricing?fundId=${fundId}&fromDate=${actualFromDate}&unitCategoryCode=${unitCategoryCodes}`;

  return axios.get<ChartData>(url)
              .then(response => response.data);
};
